<template>
  <v-app id="inspire" class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-row>
      <div class="fundo-pcm" />
      <div class="login-form">
        <v-row class="line-form">
          <v-col cols="12" align-self="center">
            <h2>Faça seu Login</h2>
            <v-text-field
              v-model="form.login"
              dense
              outlined
              append-icon="mdi-account"
              placeholder="Usuário"
              class="text-field-form"
              :disabled="disableTextInput"
            />
            <v-text-field
              v-model="form.password"
              dense
              outlined
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              placeholder="Senha"
              :disabled="disableTextInput"
              @keyup.enter="login"
              @click:append="showPassword = !showPassword"
            />
            <div class="login-button">
              <v-btn color="bluePcm" dark class="text-right" @click="login">Login</v-btn>
            </div>
          </v-col>

          <div class="login-as-operador">
            <div>ou</div>
            <v-btn text color="bluePcm" @click="goToLoginOperador">Faça login como operador</v-btn>
          </div>
        </v-row>
      </div>
    </v-row>
    <Footer />
  </v-app>
</template>

<script>
import SimpleCrypto from 'simple-crypto-js'

import Snackbar from '@/componentes/Snackbar'
import Footer from '@/componentes/Footer'
import searchPermissionServices from '@/utils/commomServices/searchPermissionServices'
import registerUserService from '@/utils/commomServices/registerUserService'

export default {
  name: 'Login',
  components: { Snackbar, Footer },
  data: () => ({
    form: {
      login: '',
      password: '',
    },
    snackbar: false,
    showPassword: false,
    text: '',
    disableTextInput: false,
  }),

  async created() {
    this.disableTextInput = true
    const token = window.localStorage.getItem('pcm_access_token')

    if (token) {
      try {
        const response = await searchPermissionServices.getMe(token)
        if (response.data.permissions.length > 0) {
          this.$router.push({ name: 'Verify_Rota' }).catch(()=>{});
        }
      } catch (err) {
        console.log(err)
        this.disableTextInput = false
      }
    }

    this.disableTextInput = false
  },

  methods: {
    goToLoginOperador() {
      this.$router.push({ name: 'loginOperador' })
    },

    async login() {
      try {
        const response = await registerUserService.postUser(this.form)
        const responsePermissions = await searchPermissionServices.getMe(response.data.access_token)

        const permissionNames = responsePermissions.data.permissions.map(permission => permission.name)
        if (permissionNames.includes(process.env.VUE_APP_CALLCENTER_OPERADOR)) {
          const confirmOperador = window.confirm('Este usuário é um operador. Deseja logar-se como operador?')

          if (confirmOperador) {
            this.$router.push({ name: 'loginOperador' })
          }
        } else {
          const simpleCrypto = new SimpleCrypto(process.env.VUE_APP_CRYPTO)

          localStorage.pcm_access_token = response.data.access_token
          localStorage.pcm_permissions = simpleCrypto.encrypt(JSON.stringify(permissionNames))

          this.$router.push({ name: 'Verify_Rota' }).catch(()=>{});
        }
      } catch (err) {
        if (err.response.status === 401) {
          this.text = err.response.data.error
          this.snackbar = true
        } else if (err.response.status === 429) {
          this.text = err.response.data.error !== undefined ? err.response.data.error : err.response.data.message
          this.snackbar = true
        }else{
          this.text = err.response.data.error
          this.snackbar = true
        }

      }
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}

.login-as-operador {
  width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.fundo-pcm {
  height: 100vh;
  width: 50vw;
  background: url('../assets/fundo-pcm.png') no-repeat center;
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.login-form {
  height: 100vh;
  min-width: 50vw;
  padding: 0 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.line-form {
  max-width: 340px;
}
.text-field-form {
  margin-top: 16px;
}
.text-field-form + text-input {
  margin-top: 8px;
}
.login-button {
  display: flex;
  justify-content: center;
}
.footer {
  z-index: 1;
}
</style>
